import { Routes, Route, Navigate } from 'react-router-dom'
import Nem from './Nem'

function WarehouseRouter() {
	const currentUser = JSON.parse(localStorage.getItem('current-user'))
	const roleAdmin = currentUser?.role === 'admin'

	if (!roleAdmin) {
		return <Navigate to='/store-manager' />
	}

	return (
		<Routes>
			<Route index element={<Nem category='fresh' />} />
		</Routes>
	)
}

export default WarehouseRouter
